export default () => {
    const menuItems = document.getElementById('navigation');
    // console.log(menuItems)
    if (!menuItems)
        return;
    import(/* webpackChunkName: "menu" */ "./../classes/menuClass")
        .then(({ default: Menu }) => {
        new Menu();
    })
        .catch(() => "An error occurred");
};
